// src/components/auth/DashboardRedirect.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const DashboardRedirect: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Rediriger selon le rôle
  return user.role === 'supervisor' 
    ? <Navigate to="/supervisor/dashboard" replace />
    : <Navigate to="/secretary/dashboard" replace />;
};

export default DashboardRedirect;